import type { BorrowMarketRow } from '@/hooks/useBorrowMarkets'
import type { PopoverProps } from '@radix-ui/react-popover'
import { BorrowMarketsRangeFilter, BorrowMarketsRangeFilterAccordion } from './borrowMarketsRangeFilter'

interface BorrowMarketSizeFilterProps extends Pick<PopoverProps, 'modal'> {
  borrowMarkets: BorrowMarketRow[]
  className?: string
}

export const BorrowMarketSizeFilter = ({ borrowMarkets, className, modal }: BorrowMarketSizeFilterProps) => (
  <BorrowMarketsRangeFilter borrowMarkets={borrowMarkets} type="marketSize" className={className} modal={modal} />
)

export const BorrowMarketSizeFilterAccordion = ({
  borrowMarkets,
}: Pick<BorrowMarketSizeFilterProps, 'borrowMarkets'>) => (
  <BorrowMarketsRangeFilterAccordion borrowMarkets={borrowMarkets} type="marketSize" />
)
